import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=7c7edd28&scoped=true"
import script from "./QuestionContent.vue?vue&type=script&lang=js"
export * from "./QuestionContent.vue?vue&type=script&lang=js"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=7c7edd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7edd28",
  null
  
)

export default component.exports